import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="video-background">
        <video autoPlay muted loop playsInline preload="metadata">
          <source src="/assets/video/Encoded_Hero_2_30Fps_720P_H264.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div>
      </div>
      
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Tu Aliado en Rastreo
            <span className="highlight"> Inteligente</span>
          </h1>
          <p className="hero-subtitle">
          Tecnología de rastreo de última generación al alcance de tu mano.
          </p>
          <div className="hero-actions">
            <a 
              href="https://wx.linksfield.net/login?partnerCode=CU-808B7L2B85WE" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-primary"
            >
              Activa tu Sim
            </a>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">11</span>
              <span className="stat-label">Años de experiencia</span>
            </div>
            <div className="stat">
              <span className="stat-number">41</span>
              <span className="stat-label">Mil dispositivos vendidos</span>
            </div>
            <div className="stat">
              <span className="stat-number">26</span>
              <span className="stat-label">Mil clientes</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 